export default __webpack_public_path__ + "img/ctQZyYFB.d991a074.svg";